import { useEffect, useState } from "react";
import {
    collection,
    getDocs,
    updateDoc,
    doc,
    query,
    orderBy,
    limit,
    getDoc, deleteDoc,
} from "firebase/firestore";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth, db } from "../../firebase"; // als je geen alias @ gebruikt
import AdminLayout from "../../layouts/AdminLayout";
import StatsOverview from "../../components/admin/StatsOverview";
import { deleteUser } from "firebase/auth";


export default function AdminDashboard() {
    const [agents, setAgents] = useState([]);
    const [bookings, setBookings] = useState([]);

    // Haal de agents en boekingen op bij het laden van de pagina
    useEffect(() => {
        fetchAgents();
        fetchRecentBookings();
    }, []);

    // Haal agents op
    const fetchAgents = async () => {
        const usersRef = collection(db, "users");
        const snapshot = await getDocs(usersRef);
        const data = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));
        setAgents(data.filter((u) => u.role === "agent")); // Filter op agents
    };

    // Activeer of deactiveer agent
    const toggleActive = async (agentId, currentStatus) => {
        const userRef = doc(db, "users", agentId);
        await updateDoc(userRef, { isActive: !currentStatus });
        fetchAgents(); // refresh
    };

    // Verstuur reset wachtwoord link
    const sendResetLink = async (email) => {
        try {
            await sendPasswordResetEmail(auth, email);
            alert(`Reset link verzonden naar ${email}`);
        } catch (err) {
            console.error(err);
            alert("Kon reset link niet versturen.");
        }
    };

    // Haal de recente boekingen op
    const fetchRecentBookings = async () => {
        const bookingsRef = collection(db, "bookings");
        const q = query(bookingsRef, orderBy("createdAt", "desc"), limit(10));
        const snapshot = await getDocs(q);

        const bookingsData = await Promise.all(
            snapshot.docs.map(async (docSnap) => {
                const data = docSnap.data();

                let propertySnap = { exists: () => false };
                let propertyData = {};

                if (data.propertyId) {
                    propertySnap = await getDoc(doc(db, "properties", data.propertyId));
                    if (propertySnap.exists()) {
                        propertyData = propertySnap.data();
                    }
                }

                return {
                    id: docSnap.id,
                    visitorName: data.name,
                    visitorPhone: data.telefoon,
                    datetime: data.createdAt ? data.createdAt.toDate() : null,
                    propertyAddress: propertyData.address || "Onbekend",
                    agentName: propertyData.makelaarNaam || "Onbekend",
                };
            })
        );

        setBookings(bookingsData);
    };
    // Verwijder gebruiker functie
    const handleDeleteAccount = async (agentId, email) => {
        const userRef = doc(db, "users", agentId);
        const user = await getDoc(userRef);
        if (user.exists()) {
            try {
                // Verwijder uit Firestore
                await deleteDoc(userRef);

                // Verwijder gebruiker uit Firebase Authentication
                const authUser = await auth.getUserByEmail(email);
                await deleteUser(authUser);  // Verwijder gebruiker uit Authentication

                alert("Account succesvol verwijderd!");
                fetchAgents(); // Refresh de lijst
            } catch (error) {
                console.error(error);
                alert("Er is een fout opgetreden bij het verwijderen van het account.");
            }
        }
    };

    return (
        <AdminLayout>
            <StatsOverview />
            <div className="p-6 space-y-10">
                {/* Geregistreerde makelaars sectie */}
                <section>
                    <h2 className="text-2xl font-bold mb-4">Geregistreerde makelaars</h2>
                    <div className="w-full overflow-x-auto">
                        <table className="w-full min-w-[700px] border text-left">
                            <thead>
                            <tr className="bg-gray-100">
                                <th className="p-2">Naam</th>
                                <th className="p-2">Email</th>
                                <th className="p-2">Telefoon</th>
                                <th className="p-2">Actief</th>
                                <th className="p-2">Acties</th>
                            </tr>
                            </thead>
                            <tbody>
                            {agents.map((agent) => (
                                <tr key={agent.id} className="border-t">
                                    <td className="p-2">{agent.voornaam} {agent.achternaam}</td>
                                    <td className="p-2">{agent.email}</td>
                                    <td className="p-2">{agent.telefoon}</td>
                                    <td className="p-2">{agent.isActive ? "✅ Ja" : "❌ Nee"}</td>
                                    <td className="p-2 space-x-2">
                                        <button
                                            className="px-2 py-1 bg-blue-600 text-white rounded"
                                            onClick={() => toggleActive(agent.id, agent.isActive)}
                                        >
                                            {agent.isActive ? "Deactiveer" : "Activeer"}
                                        </button>
                                        <button
                                            className="px-2 py-1 bg-orange-500 text-white rounded"
                                            onClick={() => sendResetLink(agent.email)}
                                        >
                                            Reset wachtwoord
                                        </button>
                                        <button
                                            className="px-2 py-1 bg-red-500 text-white rounded"
                                            onClick={() => handleDeleteAccount(agent.id, agent.email)}
                                        >
                                            Verwijder account
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </section>

                {/* Laatste boekingen sectie */}
                <section>
                    <h2 className="text-2xl font-bold mb-4">Laatste boekingen</h2>
                    <div className="w-full overflow-x-auto">
                        <table className="w-full min-w-[700px] border text-left">
                            <thead>
                            <tr className="bg-gray-100">
                                <th className="p-2">Datum & Tijd</th>
                                <th className="p-2">Bezoeker</th>
                                <th className="p-2">Telefoon</th>
                                <th className="p-2">Woning</th>
                                <th className="p-2">Makelaar</th>
                            </tr>
                            </thead>
                            <tbody>
                            {bookings.map((b) => (
                                <tr key={b.id} className="border-t">
                                    <td className="p-2">
                                        {b.datetime ? b.datetime.toLocaleString() : "Geen datum"}
                                    </td>
                                    <td className="p-2">{b.visitorName}</td>
                                    <td className="p-2">{b.visitorPhone}</td>
                                    <td className="p-2">{b.propertyAddress}</td>
                                    <td className="p-2">{b.agentName}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </AdminLayout>
    );
}
